export default "__VITE_ASSET__CTXWicPp__"